import { employersEmployerSettings } from 'rails_routes'
import { Modal } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

export const CompletionDialog = ({ open, onOpenChange }: { open: boolean, onOpenChange: (open: boolean) => void }) => {
  const { assign } = useWindowLocation()

  return (
    <Modal open={open} onOpenChange={onOpenChange} width='medium'>
      <Modal.Body>
        <Modal.Title>All employees have been matched</Modal.Title>
        <Modal.Description>
          You can now enable payroll deduction automation to streamline your benefits administration.
        </Modal.Description>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Button
          variant='primary'
          onClick={() => {
            assign(employersEmployerSettings.show({ query: { tab: 'payroll' } }))
          }}
        >
          Go to payroll settings
        </Modal.Button>
      </Modal.Footer>
    </Modal>
  )
}
